import React from 'react'
import CkEditorContainer from '../../../../Components/Miscellaneous/Editors/CkEditor'

export default function CkEditor() {
    return (
        <div className='page-body'>
            <CkEditorContainer />
        </div>
    )
}
